// src/pages/Login.js
import React, { useState } from 'react';
import {
  Box, Button, TextField, Typography, CircularProgress
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function Login() {
  const [phone, setPhone]     = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp]         = useState('');
  const [loading, setLoading] = useState(false);
  const navigate               = useNavigate();

  const requestOtp = async () => {
    setLoading(true);
    try {
      const res = await fetch('https://wg.pizzahub.lk/api/request_otp.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phone })
      });
      const data = await res.json();
      if (data.status === 'success') {
        setOtpSent(true);
      } else {
        alert(data.message);
      }
    } catch {
      alert('Network error');
    }
    setLoading(false);
  };

  const verifyOtp = async () => {
    setLoading(true);
    try {
      const res = await fetch('https://wg.pizzahub.lk/api/verify_otp.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phone, otp })
      });
      const data = await res.json();
      if (data.status === 'success') {
        localStorage.setItem('admin', JSON.stringify(data.admin));
        navigate('/dashboard');
      } else {
        alert(data.message);
      }
    } catch {
      alert('Network error');
    }
    setLoading(false);
  };

  return (
    <Box sx={{ maxWidth:360, mx:'auto', mt:8, p:3, border:1, borderColor:'grey.300', borderRadius:1 }}>
      <Typography variant="h5" gutterBottom>Admin Login</Typography>

      {!otpSent ? (
        <>
          <TextField
            label="Phone"
            fullWidth
            margin="normal"
            value={phone}
            onChange={e => setPhone(e.target.value)}
          />
          <Button
            fullWidth
            variant="contained"
            disabled={!phone || loading}
            onClick={requestOtp}
          >
            {loading ? <CircularProgress size={24}/> : 'Send OTP'}
          </Button>
        </>
      ) : (
        <>
          <Typography>OTP sent to {phone}</Typography>
          <TextField
            label="OTP"
            fullWidth
            margin="normal"
            value={otp}
            onChange={e => setOtp(e.target.value)}
          />
          <Button
            fullWidth
            variant="contained"
            disabled={!otp || loading}
            onClick={verifyOtp}
          >
            {loading ? <CircularProgress size={24}/> : 'Verify OTP'}
          </Button>
        </>
      )}
    </Box>
  );
}
